var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap"},[_c('qk_head'),_c('router-view'),_c('footer_index')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }